import * as api from '@crochik/schedulerapi.ts';
import * as moment from 'moment-timezone';

import { IdentityClient, Token } from './api/IdentityClient';

import { CalendarProps, DaySlots, Slot } from '@crochik/pi-react/ui/material/Calendar';

import Settings from './Settings';
import { utcToLongDate } from './date';

interface DaySlotsWithDict extends DaySlots {
    dict: { [key: number]: boolean };
}

export class API {
    token: Token;
    session: api.SessionConfig;
    slotsPromise?: Promise<CalendarProps>;

    get config(): api.Configuration {
        return new api.Configuration({
            basePath: Settings().apiServer,
            accessToken: this.token.access_token
        });
    }

    get schedulerApi(): api.SchedulerApi {
        return new api.SchedulerApi(this.config);
    }

    get sessionId(): string {
        if (!this.session.id) throw new Error('Missing session');
        return this.session.id;
    }

    get slots() {
        if (!this.slotsPromise) {
            this.slotsPromise = this.getSlots();
        }

        return this.slotsPromise;
    }

    async initSessionForOrganization(launchCode: string): Promise<api.SessionConfig> {
        const session = await this.schedulerApi.initSessionForOrganization_2(launchCode); // post
        if (!session || !session.id) {
            throw new Error('failed to get config');
        }

        this.session = session;

        return this.session;
    }

    async initSessionForLead(): Promise<api.SessionConfig> {
        const session = await this.schedulerApi.initSessionForLead(); 
        if (!session || !session.id) {
            throw new Error('failed to get config');
        }

        this.session = session;

        return this.session;
    }

    async createLead(body: object): Promise<api.Lead | undefined> {
        // const lead = await this.schedulerApi.addLead_1(this.sessionId, 'd52ba5a3-2e22-41c8-950c-06754364bdf7' , body);
        const lead = await this.schedulerApi.addLead(this.sessionId, 'it_will_be_ignored', body);
        return lead;
    }

    async createAppointment(body: api.AppointmentReq): Promise<api.Appointment> {
        const appointment = await this.schedulerApi.appointment(this.sessionId, body);
        return appointment;
    }

    // createAppointment(payload: api.AppointmentReq): Promise<api.LeadAdded> {
    //     var api = this.schedulerApi;
    //     return api.appointment(payload);
    // }

    // getFutureAppointments(): Promise<api.Appointment[]> {
    //     return this.schedulerApi.getFutureAppointments();
    // }

    // async cancelAppointment(): Promise<any> {
    //     await this.schedulerApi.cancelAppointment();
    // }

    // async getConfig(appointmentTypeId: string): Promise<api.SessionConfig> {
    //     var config = await this.schedulerApi.getSession(appointmentTypeId);
    //     // this.process(config);
    //     return config;
    // }

    // process(session: api.SessionConfig) {
    //     const config = {
    //         forms: [],
    //         pages: [],
    //         menus: [],
    //     };

    //     console.log('session', session);

    //     if (config.forms) {
    //         config.forms.forEach((form) => Form.create(form as IForm));
    //     }

    //     if (config.pages) {
    //         config.pages.forEach((page) => createPage(page as IPage));
    //     }

    //     if (config.menus) {
    //         config.menus.forEach((menu) => Menu.create(menu as IMenu));
    //     }

    //     return config;
    // }

    private async getSlots(): Promise<CalendarProps> {
        const start = moment().startOf('day');
        const end = start.clone().add(28, 'days');

        var slots = await this.schedulerApi.getSlots(
            this.sessionId,
            start.toDate(),
            end.toDate()
        );

        return this.convert(start, end, slots);
    }

    private convert(startDate: moment.Moment, endDate: moment.Moment, json: api.TimeSlot[]): CalendarProps {
        var start: number = -1;
        var end: number = -1;
        var days: DaySlotsWithDict[] = [];

        var dict: { [id: string]: DaySlotsWithDict } = {};

        for (var day = startDate.startOf('day'); day.isBefore(endDate); day.add(1, 'day')) {
            var d: DaySlotsWithDict = {
                id: day.toString(),
                title: utcToLongDate(day.toDate()),
                slots: [],
                dict: {}
            };

            dict[day.format('YYYY-MM-DD')] = d;

            days.push(d);
        }

        json.forEach(record => {
            const mStart = moment(record.start);
            const mEnd = moment(record.end);
            let startOfDay = mStart.clone().startOf('day');

            const id = startOfDay.format('YYYY-MM-DD');

            let day = dict[id];
            if (!day) {
                console.log(`date out of range: ${id}`);
                return;
            }
            const startMinutes = mStart.diff(startOfDay, 'minutes');
            const endMinutes = mEnd.diff(startOfDay, 'minutes');

            var slot: Slot = {
                date: id,
                start: startMinutes,
                duration: endMinutes - startMinutes,
                id: id + '.' + startMinutes,
            };

            day.slots.push(slot);
        });

        var props: CalendarProps = {
            start,
            end,
            interval: 30, // get from api?
            days,

            // controller
            offY: 35,
            height: 30,
            showSlotLabels: true,
        };

        return props;
    }
}

var instance: API;
export default function get() {
    return instance;
}

export async function init() {
    const settings = Settings().idp;
    const client = new IdentityClient(settings.authority as string);
    const resp = await client.singInWithSecret(settings);
    
    const api = new API();
    api.token = resp as Token;

    instance = api;

    return api;
}

export function createSession(token: string): API {
    const api = new API();

    api.token = {
        access_token: token,
        expires_in: 3600, // 1 hour
        token_type: 'Bearer'
    };

    instance = api;
    
    return api;
}


// WEBPACK FOOTER //
// ./src/app/services/API.ts